import axiosInstance from "./AxiosInstance";

// --------------------- ASSET CATEGORY SERVICES ---------------------

export function getAllAssetCategories(params = {}) {
  return axiosInstance.get("/api/asset-category/", { params });
}

export function getAssetCategoryById(id) {
  return axiosInstance.get("/api/asset-category/", { params: { id } });
}

export function createAssetCategory(data) {
  return axiosInstance.post("/api/asset-category/", data);
}

export function updateAssetCategory(id, data) {
  return axiosInstance.put("/api/asset-category/", { ...data, id });
}

export function patchAssetCategory(id, data) {
  return axiosInstance.patch("/api/asset-category/", { ...data, id });
}

// Upload Excel for Asset Category
export function uploadAssetCategoryExcel(file) {
  const formData = new FormData();
  formData.append("file", file);

  return axiosInstance.post("/api/asset-category/", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

// Export Excel for Asset Category
export function exportAssetCategoriesToExcel(params = {}) {
  return axiosInstance.get("/api/asset-category/", {
    params: { ...params, export: "excel" },
    responseType: "blob",
  });
}



// ------------------ ASSET SUBCATEGORY SERVICES ----------------------

export function getAllAssetSubCategories(params = {}) {
  return axiosInstance.get("/api/asset-subcategory/", { 
    params,
    validateStatus: (status) => status < 500
  });
}

export function getAssetSubCategoryById(id) {
  return axiosInstance.get(`/api/asset-subcategory/`, { params: { id } });
}

export function createAssetSubCategory(data) {
  return axiosInstance.post("/api/asset-subcategory/", data);
}

export function updateAssetSubCategory(id, data) {
  return axiosInstance.put(`/api/asset-subcategory/`, { ...data, id });
}

export function patchAssetSubCategory(id, data) {
  return axiosInstance.patch(`/api/asset-subcategory/`, { ...data, id });
}

export function uploadAssetSubCategoryExcel(file) {
  const formData = new FormData();
  formData.append("file", file);

  return axiosInstance.post("/api/asset-subcategory/upload-excel/", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function exportAssetSubCategories(params = {}) {
  return axiosInstance.get("/api/asset-subcategory/export/", {
    params: { ...params, export: "excel" },
    responseType: "blob",
    validateStatus: (status) => status < 500
  });
}

// ---------------------- FILE DOWNLOAD HELPER -----------------------

export function triggerFileDownload(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(url);
}
